import { Place } from 'cube'

export const ParamIds = {
    // :: Analise de Reacoes
    analiseReacoesTemDados: 'm1-tda',
    analiseReacoesDtInicial: 'm1-dti',
    analiseReacoesDtFinal: 'm1-dtf',
    analiseReacoesBuscaGeral: 'm1-grl',
    analiseReacoesBuscaReacoes: 'm1-rac',
    analiseReacoesBuscaMedicamentos: 'm1-mds',
    analiseReacoesStatusBula: 'm1-sbl',
    analiseReacoesGravidade: 'm1-grv',

    // :: Analise de Bulas
    analiseBulasTemDados: 'm2-tda',
    analiseBulasPrincipioAtivos: 'm2-pra',
    analiseBulasFabricantes: 'm2-fbr',
    analiseBulasMecicamentos: 'm2-mds',
    analiseBulasReacoes: 'm2-rac',
}

export const AttrIds = {
    parentSlot: 'parent-slot',
    dialogSlot: 'dialog-slot'
}

export const Places = {
    main: Place.ROOT,
    analiseBulas: Place.UNKNOWN,
    analiseReacoes: Place.UNKNOWN
}